import propTypes from 'prop-types'
import cn from 'classnames'

const SelectableItemLabel = ({
  status,
  label = 'n/a',
  subLabel = 'n/a',
}) => {
  return (
    <div className="selectable-item-label">
      <div className="selectable-item-label__left">
        <span
          className={cn('selectable-item-label__dot', {
            '-available': status === 'available',
            '-low-on-inventory': status === 'low-on-inventory',
            '-unavailable': status === 'unavailable',
          })}
        ></span>
      </div>
      <div className="selectable-item-label__right">
        <div className="selectable-item-label__label">{label}</div>
        <div className="selectable-item-label__sub-label">
          {subLabel}
        </div>
      </div>
    </div>
  )
}

SelectableItemLabel.propTypes = {
  status: propTypes.string,
  label: propTypes.string,
  subLabel: propTypes.string,
}

export default SelectableItemLabel
